import React from "react";
import { ValueStep } from "../types/quiz";
import { PrimaryButton } from "./PrimaryButton";
import { ValueVisual } from "./ValueVisual";
import { withName } from "../utils/name";
interface ValueScreenProps {
  step: ValueStep;
  name: string;
  onContinue: () => void;
}
export function ValueScreen({
  step,
  name,
  onContinue
}: ValueScreenProps) {
  return <section className="mx-auto max-w-2xl px-4 py-8 sm:px-6 md:py-12" aria-labelledby={`${step.id}-title`} data-id="element-420" data-mp="1v46kjlispo9m">
      <p className="text-base font-semibold text-olive-700" data-id="element-421" data-mp="ye5t1er1ktom">{withName(step.eyebrow, name)}</p>
      <h2 id={`${step.id}-title`} className="mt-2 font-serif text-3xl font-semibold leading-tight text-cocoa sm:text-4xl" data-id="element-422" data-mp="12f7wk7rzrrwe">
        {withName(step.title, name)}
      </h2>

      {step.image && <img src={step.image} alt="Comparación entre un plato frío y crudo y una cena caliente y cocida" className="mt-6 aspect-[16/9] w-full rounded-2xl object-cover" data-id="element-423" data-mp="1c9hpbqkuis7n" />}

      <div className="mt-6 space-y-4 text-lg leading-relaxed text-cocoa" data-id="element-424" data-mp="2npg4mc6maahb">
        {step.paragraphs.map(p => <p key={p} data-id="element-425" data-mp="24hez3uxr4vjr">{p}</p>)}
      </div>

      {step.list && <ul className="mt-4 flex flex-wrap gap-2" data-id="element-426" data-mp="20he7f8ln6nur">
          {step.list.map(item => <li key={item} className="rounded-full border border-blush-200 bg-white px-3.5 py-1.5 text-sm text-cocoa-soft line-through decoration-coral-600/60" data-id="element-427" data-mp="20f0byyn1v9mo">
              {item}
            </li>)}
        </ul>}

      {step.closing && <p className="mt-6 font-serif text-xl font-semibold leading-snug text-rose-600" data-id="element-428" data-mp="1ljlveqfb0hlb">{step.closing}</p>}

      {step.visual && <div className="mt-7" data-id="element-429" data-mp="1gsvrziqfuot9">
          <ValueVisual kind={step.visual} data-id="element-430" data-mp="1grucn22e3g5q" />
        </div>}

      {step.testimonial && <figure className="mt-7 border-l-4 border-rose-400 pl-5" data-id="element-431" data-mp="1csbsi8ie793y">
          <blockquote className="font-serif text-lg italic leading-relaxed text-cocoa" data-id="element-432" data-mp="17spc5q79pcqx">“{step.testimonial.quote}”</blockquote>
          <figcaption className="mt-2 text-sm font-medium text-cocoa-soft" data-id="element-433" data-mp="12sb6get52ew2">— {step.testimonial.author}</figcaption>
        </figure>}

      <div className="mt-9" data-id="element-434" data-mp="xv1h0z5r2388">
        <PrimaryButton onClick={onContinue} data-id="element-435" data-mp="o6nmouqulcdq">{step.cta}</PrimaryButton>
      </div>
    </section>;
}